var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 60,
    viewBox: "0 0 46 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m43.687 12.453-11.3-10.69A6.42 6.42 0 0 0 27.959 0H6.445A6.453 6.453 0 0 0 0 6.445v47.11A6.453 6.453 0 0 0 6.445 60h32.813a6.453 6.453 0 0 0 6.445-6.445v-36.42c0-1.763-.735-3.47-2.016-4.682Zm-3.414 1.61h-8.75a.587.587 0 0 1-.585-.586V5.23l9.335 8.832Zm-1.015 42.421H6.445a2.933 2.933 0 0 1-2.93-2.93V6.446a2.933 2.933 0 0 1 2.93-2.93h20.977v9.962a4.106 4.106 0 0 0 4.101 4.101h10.665v35.977a2.933 2.933 0 0 1-2.93 2.93Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.39 23.438H9.61a1.758 1.758 0 0 0 0 3.515h25.78a1.758 1.758 0 0 0 0-3.515ZM35.39 32.813H9.61a1.758 1.758 0 0 0 0 3.515h25.78a1.758 1.758 0 0 0 0-3.516ZM18.131 42.187H9.61a1.758 1.758 0 0 0 0 3.516h8.522a1.758 1.758 0 0 0 0-3.516Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile);
export default __webpack_public_path__ + "static/media/file.8b943a6a.svg";
export { ForwardRef as ReactComponent };